"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSafeColSettings = exports.settingsSchema = void 0;
exports.settingsSchema = {
    type: "object",
    fields: [
        {
            id: "disableAdd",
            title: "禁止新增",
            type: "boolean"
        },
        {
            id: "disableDelete",
            title: "禁止删除",
            type: "boolean"
        },
        {
            id: "disableDrag",
            title: "禁止拖拽",
            type: "boolean"
        },
        {
            id: "hideNumber",
            title: "隐藏序号",
            type: "boolean"
        },
        {
            id: "cols",
            type: "array",
            items: {
                type: "object",
                fields: [
                    { id: "id", type: "string", required: true },
                    { id: "title", type: "string" },
                    { id: "description", type: "string" },
                    { id: "width", type: "string" },
                    { id: "readonly", type: "boolean" },
                ]
            }
        },
    ]
};
function getSafeColSettings(cols, arrayStub) {
    const elStub = arrayStub.getChildStub(0);
    const fieldsX = (elStub === null || elStub === void 0 ? void 0 : elStub.type) === 'object' && (cols === null || cols === void 0 ? void 0 : cols.length) && elStub.getFields();
    if (!fieldsX) {
        return [{ id: "", title: (elStub === null || elStub === void 0 ? void 0 : elStub.schema.title) || '' }];
    }
    const fields = [...fieldsX.fields, ...fieldsX.candidates];
    const ans = [];
    cols.forEach(col => {
        const fieldSchema = fields.find(x => x.id === col.id);
        if (!fieldSchema)
            return;
        ans.push(Object.assign(Object.assign({}, col), { title: col.title || fieldSchema.title || col.id, description: String(col.description || fieldSchema.description || "").trim() }));
    });
    return ans;
}
exports.getSafeColSettings = getSafeColSettings;
//# sourceMappingURL=arrayTable.js.map